import TagManager from "react-gtm-module";
import { useSelector } from "react-redux";
import auth from "../components/Layout/util/auth";
import { callGTMCTAClick, reachUsGTMCTAClick } from "./gtmutil";
import cookie from "js-cookie";

export const toggleBodyScroll = (startScroll = false) => {
  const body = document.getElementsByTagName("body")[0];
  if (body) {
    !startScroll && body.classList.add("no-scroll");
    startScroll && body.classList.remove("no-scroll");
  }
};

export const share = (data) => {
  window.location.href = "tel:+918069510565";
  const r = auth();
  callGTMCTAClick(r, "reachUs", "login", "Guest", "", "", cookie.get("_gid"));
  // const url =
  //   "https://wa.me/+919999131131/?text=Hi, I have some queries regarding NFTs.";
  // const newWin = window.open(url, "_blank");
  // if (!newWin || newWin.closed || typeof newWin.closed === "undefined") {
  //   return false;
  // }
  // return true;
};
export const reachUs = (data) => {
  console.log("Print data value here", data);
  0;
  const r = auth();
  reachUsGTMCTAClick(
    r,
    "reachUs",
    data,
    "reachUs",
    "login",
    "Guest",
    "",
    cookie.get("_gid")
  );
  const url = "https://wa.me/+918527376969/?text=Hi, I have some queries.";
  const newWin = window.open(url, "_blank");
  if (!newWin || newWin.closed || typeof newWin.closed === "undefined") {
    return false;
  }
  return true;
};

export const reachUsforLandingPage = (data) => {
  console.log("Print data value here", data);
  0;
  const r = auth();
  reachUsGTMCTAClick(
    r,
    "reachUs",
    data,
    "reachUs",
    "login",
    "Guest",
    "",
    cookie.get("_gid")
  );
  const url = "https://wa.me/+918527375454/?text=Hi, I have some queries.";
  const newWin = window.open(url, "_blank");
  if (!newWin || newWin.closed || typeof newWin.closed === "undefined") {
    return false;
  }
  return true;
};

const r = auth();

export const enquireNow = (data) => {
  callGTMCTAClick(
    r,
    "enquireNow",
    "login",
    "Guest",
    "+918069510565",
    r?.email,
    cookie.get("_gid"),
    window.location.pathname,
    window.location.pathname
  );

  window.location.href = "tel:+918069510565";
};
export const callNow = (e, tierId, data) => {
  callGTMCTAClick(
    r,
    "callNow",
    "login",
    "Guest",
    "+918069510565",
    r?.email,
    cookie.get("_gid"),
    window.location.pathname,
    window.location.pathname
  );
  window.location.href = "tel:+918069510565";
};

export const checkPercentage = (
  totalTokenAmount,
  balance,
  fantigerCoinValue,
  country_code,
  promoCode
) => {
  var total = totalTokenAmount;
  var bal = balance;
  var promoCodeValue = promoCode;
  var coin;
  if (country_code == "IN") {
    coin = Number(fantigerCoinValue / 100);
    total = totalTokenAmount * 80;
    bal = balance * 80;
    promoCodeValue = promoCode * 80;
  } else {
    coin = Number(fantigerCoinValue / 8000);
  }
  if (bal + coin + promoCodeValue < total) {
    const diff = parseFloat((total - (bal + coin)).toFixed(2));
    // const percentageDiff = (diff / total) * 100;
    if (diff.toFixed(2) <= 0.00125 && country_code != "IN") {
      return true;
    } else if (diff.toFixed(2) <= 0.1 && country_code == "IN") {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const numFormatter = (num) => {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + " K"; // convert to K for number from > 1000 < 1 million
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(0) + " Mn"; // convert to M for number from > 1 million
  } else if (num < 900) {
    return num; // if value < 1000, nothing to do
  }
};

export const numFormatter2 = (num) => {
  return num.toFixed(0);
  // console.log("🚀 ~ file: common.js ~ line 143 ~ numFormatter ~ num", num);
  // if (num > 999 && num < 1000000) {
  //   return (num / 1000).toFixed(0) + " K"; // convert to K for number from > 1000 < 1 million
  // } else if (num >= 1000000) {
  //   return (num / 1000000).toFixed(0) + " Mn"; // convert to M for number from > 1 million
  // } else if (num < 900) {
  //   return num; // if value < 1000, nothing to do
  // }
};

export const getPercentage = (partialValue, totalValue) => {
  return (100 * partialValue) / totalValue;
};

export const coinToINR = (coin) => {
  return Math.round(coin / 100);
};
export const coinToUSD = (coin) => {
  return Math.round(coin / 8000);
};

export const INRToUSD = (coin) => {
  return "$" + (coin / 80).toFixed(4);
};

export function ConvertToKLacCr(value, country_code = "IN") {
  if (country_code == "IN") {
    var val = value;
    if (val <= 999) {
      val = "₹" + val.toFixed(0);
    } else if (val > 999 && val < 100000) {
      val = "₹" + (val / 1000).toFixed(0) + " K";
    } else if (val >= 100000 && val < 10000000) {
      val = "₹" + (val / 100000).toFixed(2) + " Lacs";
    } else if (val >= 10000000) {
      val = "₹" + (val / 10000000).toFixed(2) + " Cr";
    }
    return val;
  } else {
    var val = (value / 80).toFixed(2);
    if (val <= 999) {
      val = "$" + Math.round(val);
    } else if (val > 999 && val < 1000000) {
      val = "$" + (val / 1000).toFixed(0) + " K";
    } else if (val >= 1000000 && val < 1000000000) {
      val = "$" + (val / 1000000).toFixed(2) + "Mn";
    } else if (val >= 10000000000) {
      val = "$" + (val / 10000000).toFixed(2) + "Bn";
    }
    return val;
  }
}

export function ConvertToKLacCr10K(value, country_code = "IN") {
  if (country_code == "IN") {
    var val = value;
    if (val < 10000) {
      val = "₹" + val.toFixed(0);
    } else if (val >= 10000 && val < 100000) {
      val = "₹" + (val / 1000).toFixed(1) + " K";
    } else if (val >= 100000 && val < 10000000) {
      val = "₹" + (val / 100000).toFixed(2) + " Lacs";
    } else if (val >= 10000000) {
      val = "₹" + (val / 10000000).toFixed(2) + " Cr";
    }
    return val;
  } else {
    var val = (value / 80).toFixed(2);
    if (val <= 999) {
      val = "$" + Math.round(val);
    } else if (val > 999 && val < 1000000) {
      val = "$" + (val / 1000).toFixed(0) + " K";
    } else if (val >= 1000000 && val < 1000000000) {
      val = "$" + (val / 1000000).toFixed(2) + "Mn";
    } else if (val >= 10000000000) {
      val = "$" + (val / 10000000).toFixed(2) + "Bn";
    }
    return val;
  }
}

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const countryBasedPrice = (value, country_code = "IN") => {
  if (country_code == "IN") {
    return "₹" + (value * 80).toFixed(2);
  } else if (country_code == "OTHER") {
    return "$" + value;
  }
};
export const countryBasedPriceRounded = (value, country_code = "IN") => {
  if (country_code == "IN") {
    return "₹" + (Math.round(value * 80 * 100) / 100).toFixed(2);
  } else if (country_code == "OTHER") {
    return "$" + (Math.round(value * 100) / 100).toFixed(2);
  }
};

export function isWhatPercentOf(numA, numB) {
  return Math.round((numA / numB) * 100);
}

export const calculateProfileLoss = (currentPrice, salePrice) => {
  var percent = 0;
  var amount = 0;
  var returnType = "";
  if (currentPrice > salePrice) {
    amount = currentPrice - salePrice;
    percent = (amount / salePrice) * 100;
    returnType = "profit";
  }

  if (currentPrice < salePrice) {
    amount = currentPrice - salePrice;
    percent = Math.abs((amount / salePrice) * 100);
    returnType = "loss";
  }
  return {
    percent: percent.toFixed(2),
    amount: amount.toFixed(2),
    returnType: returnType,
  };
};
let param1 = `scrollbars=no,resizable=yes,status=no,location=no,toolbar=no,menubar=no,
width=800,height=800,left=100,top=100`;

export function openLinkInNewTab(url) {
  window?.open(url, "test", param1);
}

export const getThumbnailUrl = (videoObj) => {
  const [thumbnailConfig] = videoObj.thumbnails;
  return `${thumbnailConfig.parentUrl}${thumbnailConfig.path}`;
};

export const getVideoUrl = (videoObj) => {
  const { parentUrl, hls } = videoObj.cdnLocation;
  return `${parentUrl}${hls}`;
};

export const getThumbnailUrlHome = (thumbnails) => {
  const [thumbnailConfig] = thumbnails;
  return `${thumbnailConfig.parentUrl}${thumbnailConfig.path}`;
};
export const getVideoUrlHome = (cdnLocation) => {
  const { parentUrl, hls } = cdnLocation;
  return `${parentUrl}${hls}`;
};

export function formatStreams(total_streams) {
  let value = "";
  if (total_streams >= 1000000)
    value = Math.abs(Number(total_streams) / 1.0e6).toFixed(0) + " Mn+";
  else value = Math.abs(Number(total_streams) / 1.0e3).toFixed(0) + " K+";
  return value;
}

export const timeSince = (date) => {
  const intervals = [
    { label: "year", seconds: 31536000 },
    { label: "month", seconds: 2592000 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 },
  ];

  let seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 0) seconds = 2;
  const interval = intervals.find((i) => i?.seconds < seconds);
  const count = Math.floor(seconds / interval?.seconds);
  return `${count} ${interval?.label}${count !== 1 ? "s" : ""} ago`;
};
export const getViews = (views, digits = 1) => {
  const viewsLookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
  ];

  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

  const item = viewsLookup
    .slice()
    .reverse()
    .find((item) => views >= item.value);

  return item
    ? (views / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
    : "0";
};
